import type {
  ThemeOptions,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants
} from '@mui/material/styles';
import type { Theme } from '@ui/ThemeRegistry/theme.types';

const defaultProps: ComponentsProps['HeaderNavLinkNested'] = {};

const styleOverrides: ComponentsOverrides<Theme>['HeaderNavLinkNested'] = {
  root: ({ theme }) => ({
    'display': 'block',
    'width': '100%',
    'borderRadius': theme.shape.borderRadius,
    'transition': 'background-color 0.3s ease',
    'padding': 'var(--grid-gap-quarter)',
    'margin': 0,
    // 'backgroundColor': 'transparent !important', // No background by default

    // Only apply hover effect to items that are not column headers
    '&:not([data-variant="group"]):hover': {
      'backgroundColor': 'var(--mui-palette-accent-main) !important', // Darker navy background on hover for the entire item
      '& [class*="HeaderNavLinkNested-navItemLink"]': {
        backgroundColor: 'var(--mui-palette-accent-main)',
        color: 'var(--mui-palette-accent-contrastText)',
        textDecoration: 'none !important'
      }
    }
  }),

  navItemLink: ({ theme }) => ({
    'padding': 'var(--grid-gap-quarter)',
    'marginLeft': theme.spacing(-3), // Offsets hover padding background
    'cursor': 'pointer',
    'fontWeight': 900, // Extra bold font weight for nested items
    'textDecoration': 'none !important', // Removing underlines
    'borderRadius': theme.shape.borderRadius,
    'transition': 'color 0.3s ease',
    'display': 'block',
    'width': '100%',
    'backgroundColor': 'transparent !important', // No background by default

    // No hover styles here - they're applied to the parent element

    // For links in column headers, ensure no background
    '&[data-variant="group"]': {
      'backgroundColor': 'transparent !important',
      '&:hover': {
        backgroundColor: 'var(--mui-palette-accent-main)',
        color: 'var(--mui-palette-accent-contrastText)'
      }
    },

    '.MuiSvgIcon-root': {
      fill: theme.vars.palette.primary.main,
      width: 'auto',
      height: '14px',
      marginLeft: 'var(--grid-gap-half)'
    }
  })
};

const createVariants = (_theme: Theme): ComponentsVariants['HeaderNavLinkNested'] => [];

export const headerNavLinkNestedTheme = (theme: Theme): ThemeOptions => ({
  components: {
    HeaderNavLinkNested: {
      defaultProps,
      styleOverrides,
      variants: createVariants(theme)
    }
  }
});

export default headerNavLinkNestedTheme;
